import { urlServer } from '../mapboxgl/index.js'
//const urlServer='http://ec2-52-38-222-183.us-west-2.compute.amazonaws.com'
//const urlServer='http://localhost:3000'
export const getDateMosaico = async (param) =>{
    try{
        let url = `${urlServer}/incendios/update/layer?name=${param['name']}`
        const response = await fetch(url)
        //console.log('response', response.json())
        return await response.json()
    }catch(err){
        return err
    }
}

export const getPredictedOverpasses = async (param) =>{
    try{
        let url = `${urlServer}/incendios/update/predicted_overpasses?name=${param['name']}`
        const response = await fetch(url)
        const data = await response.json()
        
        // Sustituir la URL base en cada objeto del array
        const oldUrlBase = 'http://www.conabio.gob.mx/mapaservidor/incendios/overpasses/predicted_overpasses'
        const newUrlBase = `${urlServer}/incendios/update/predicted_overpasses`
        
        const modifiedData = data.map(item => ({
            ...item,
            url: item.url.replace(oldUrlBase, newUrlBase)
        }))
        
        return modifiedData
    }catch(err){
        return err
    }
}
